import { call, put, takeEvery } from 'redux-saga/effects'
import * as commonLogActions from '../ducks/commonLogDucks'
import * as commonLogApi from '../../api/commonLogApi'

interface FetchCommonLogListSaga {
  type: string
  payload: string
}

function* fetchListCategorie({ payload: queryString }: FetchCommonLogListSaga) {
  try {
    const res: ReturnType<typeof commonLogApi.getListCommonLog> = yield call(commonLogApi.getListCommonLog, queryString)
    yield put(commonLogActions.getListCommonLogSuccess(res))
  } catch (error) {
    yield put(commonLogActions.getListCommonLogFail(error))
  }
}

export default function* watchCommonLog() {
  yield takeEvery(commonLogActions.getListCommonLog.toString(), fetchListCategorie)
}
